<div class="pages-wrapper">
  <div class="header">
    <app-header />
  </div>
  <div class="content">
    <router-outlet />
  </div>
</div>
